module.exports = __webpack_public_path__ + "static/media/swingHandle_black.ff1a6a40.png";